const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '')

const ensureLeadingSlash = (value) => {
  const normalized = String(value || '/api').trim()
  if (!normalized) return '/api'
  return normalized.startsWith('/') ? normalized : `/${normalized}`
}

const DEFAULT_DEV_API_PROTOCOL = 'http'
const DEFAULT_DEV_API_HOST = '192.168.2.243'
const DEFAULT_DEV_API_PORT = '3010'
const DEFAULT_API_PREFIX = '/api'

const buildDevApiUrl = () => {
  const explicitUrl = trimTrailingSlash(process.env.REACT_APP_API_URL)
  if (explicitUrl) return explicitUrl

  const protocol = String(process.env.REACT_APP_API_PROTOCOL || DEFAULT_DEV_API_PROTOCOL).replace(/:$/, '')
  const hostname = String(process.env.REACT_APP_API_HOST || DEFAULT_DEV_API_HOST).trim() || DEFAULT_DEV_API_HOST
  const port = String(process.env.REACT_APP_API_PORT || DEFAULT_DEV_API_PORT).trim()
  const prefix = ensureLeadingSlash(process.env.REACT_APP_API_PREFIX || DEFAULT_API_PREFIX)

  return `${protocol}://${hostname}${port ? `:${port}` : ''}${prefix}`
}

export default {
  apiUrl() {
    if (process.env.NODE_ENV === 'development') {
      return buildDevApiUrl()
    }

    return trimTrailingSlash(process.env.REACT_APP_API_URL) || '/api'
  },
  test() {
    return buildDevApiUrl()
  }
}
